import { Label, Space, TextButton } from '@procurify/ui'
import { Link } from 'react-router-dom'

import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

// Remove this when AP_10171_AP_INLINE_EDITS is removed
export const APItemMatchedPOItemCell = ({
  billItemUuid,
  onDetailsClick,
  poNumber,
  poUuid,
  detailsButtonAnalyticsId,
}: ColumnTypeData['AP_ITEM_MATCHED_PO_ITEM']) => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return poUuid ? (
    <Space direction='horizontal' align='center' justify='start'>
      <Space.Item>
        <Link
          to={url('PurchaseOrderDetailsPage', {
            uuid: poUuid,
          })}
          target={'_blank'}
          rel={'noreferrer'}
        >
          <Label
            label={intl.formatMessage(messages.purchasedOrderLabel)}
            aria-label={intl.formatMessage(
              messages.purchaseOrderLabelAriaLabel
            )}
          >
            {poNumber}
          </Label>
        </Link>
      </Space.Item>
      <Space.Item>
        <TextButton
          onClick={() => onDetailsClick(billItemUuid)}
          analyticsId={detailsButtonAnalyticsId}
        >
          {intl.formatMessage(messages.detailsButtonText)}
        </TextButton>
      </Space.Item>
    </Space>
  ) : null
}
